"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapNode = void 0;
const Node_1 = require("./Node");
const DataModel_1 = require("../model/DataModel");
/**
 * Map nodes similar to list nodes, but a string key is required to add children
 */
const MapNode = (keys, children, config) => {
    return {
        ...Node_1.Base,
        type: () => 'map',
        default: () => ({}),
        navigate(path, index) {
            const nextIndex = index + 1;
            const pathElements = path.getArray();
            if (pathElements.length <= nextIndex) {
                return this;
            }
            return children.navigate(path, nextIndex);
        },
        pathPush(path, key) {
            return path.modelPush(key);
        },
        suggest: (path) => keys.suggest(path, ''),
        validate(path, value, errors, options) {
            if (options.loose && typeof value !== 'object') {
                value = options.wrapLists ? DataModel_1.DataModel.wrapLists(this.default()) : this.default();
            }
            if (value === null || typeof value !== 'object') {
                errors.add(path, 'error.expected_object');
                return value;
            }
            const res = {};
            Object.keys(value).forEach(k => {
                keys.validate(path, k, errors, options);
                res[k] = children.validate(path.push(k), value[k], errors, options);
            });
            for (const a of Object.getOwnPropertySymbols(value)) {
                res[a] = value[a];
            }
            return res;
        },
        validationOption(path) {
            var _a;
            return (_a = config === null || config === void 0 ? void 0 : config.validation) !== null && _a !== void 0 ? _a : keys.validationOption(path.push(''));
        },
        hook(hook, path, ...args) {
            var _a;
            return ((_a = hook.map) !== null && _a !== void 0 ? _a : hook.base).call(hook, { node: this, keys, children, config: config !== null && config !== void 0 ? config : {} }, path, ...args);
        }
    };
};
exports.MapNode = MapNode;
